import * as React from 'react';
import { useState, useEffect } from "react";
import Cart from "@system/config/cart";
import Modal from 'src/component/Global/Modal';
import noImage from 'src/assets/images/noimage.png'
import Helper from 'src/support/Helper';
import Product from '@system/config/product';
import { useBOMStore } from "../../../hooks/bom";
import DisplayDescriptionAndManufacturerName from 'src/component/Product/DisplayDescriptionAndManufacturerName';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { useProductInventoryStore } from 'src/hooks/productInventory';

const AddedToCartBomPopup = () => {
    const [status, SetStatus] = useState(false);
    const [{ AddedToCartBomPopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ bom_detail_by_bom_id,bom_detail_by_bom_id_type}] = useBOMStore();
    const [cartData, setCartData] = useState([]);
    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();

    useEffect(() => {
        if (AddedToCartBomPopup) {
            setCartData(AddedToCartBomPopup && AddedToCartBomPopup.data && AddedToCartBomPopup.data.cartData)
            SetStatus(true)
            addtoCartEvent();
        }
    }, [AddedToCartBomPopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };
    const getSubTotal = () => {
        let subtotal = 0;
        if (cartData.length > 0) {
            cartData.map((v) => {
                subtotal = subtotal + v.subtotal
            })
            return Helper.getFormatNumber(Number(subtotal), window.mct, window.mcs, 2, true, false)
        }
    }

    //By Ramya Kannan [Add to cart/BOM - Adobe script ]
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    function addtoCartEvent() {
      let prodDetails = Array.isArray(AddedToCartBomPopup?.data?.prodDetails) ? AddedToCartBomPopup?.data?.prodDetails : [AddedToCartBomPopup?.data?.prodDetails];
      let bomDetails = { bom_detail_by_bom_id };
      let bomCartDetails = [AddedToCartBomPopup?.data?.cartData];
      bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
      bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
      bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
      if (bom_project_list) {
        bomDetails.projectName =
          bom_project_list[bomDetails?.projectId]?.projectName;
      }
        prodDetails = prodDetails?.map((data, index) => {
            return {
                ...data,
                qas: getInventory(data?.ERPPartNumber)?.qas,
                priceSource: bomCartDetails[index]?.priceSource,
                unitPrice: bomCartDetails[index]?.unitPrice,
                subtotal: bomCartDetails[index]?.subtotal
            }
        })
      let cartDetails = {
        additionSource: "BOM",
        cartType: "checkout",
        cartId:AddedToCartBomPopup?.data?.cartData[0]?.cartId
      };
      localStorage.setItem("adobeEventType", "addToCartEvent");
      if (Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
        HelperAdobeEvent.trackingAdobeEvent({
          prodDetails,
          cartDetails,
          bomDetails,
        });
      }
    }

     //added by Ramya [Adobe script]
  const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber)
  };
 
    return (
        <>
            <div>
                <Modal show={status} onHide={() => { onHide() }}>
                    {(cartData !== undefined && cartData.length > 0) &&
                        <div className="avnet-modal modal-680">
                            <div className="avnet-modal-inner">
                                {/* Modal Header */}
                                <button type="button" className="close py-3" data-dismiss="modal"
                                    onClick={() => { onHide() }}
                                >×</button>
                                <div className="modal-header justify-content-center mt-0">
                                    <h3 className="pcn-modal-heading pl-5">({cartData.length}) Item(s) Added to Your Cart</h3>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="clearfix" />
                                    <div className="add-to-cart-list ordercartlist">
                                        {cartData.map((v, i) => (
                                            <div key={i} className="add-to-cart-item">
                                                <div className="bs5 row m-0">
                                                    <div className="col-auto p-0">
                                                        <div className="add-to-cart-item-img">
                                                            <img className="img-fluid" src={v.assetURL !== undefined && v.assetURL !== null && v.assetURL.trim() !== '' ? v.assetURL : noImage} />
                                                        </div>
                                                    </div>
                                                    <div className="col-auto p-0">
                                                        <div className="add-to-cart-item-info">
                                                            <a className="text-blue cursor-pointer text-wrap text-break bs5 d-inline-block"
                                                                href={Product.getProductDetailPageRouteURLWithCustomParameter(v) +
                                                                    "?ItemNumber=" + v.itemNumber} >
                                                                <b>{v.erpMfrPartNumber}</b>
                                                            </a>
                                                            <DisplayDescriptionAndManufacturerName currentProduct={v} />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-sm-auto mt-3 mt-sm-0 ms-auto p-0">
                                                        <div className="add-to-cart-price">
                                                            <div className="add-to-cart-price-item">
                                                                <span>Unit Price:</span>
                                                                <b>{Helper.getFormatNumber(Number(v.unitPrice), window.mct, window.mcs, 5)} </b>
                                                            </div>
                                                            <div className="add-to-cart-price-item">
                                                                <span>Quantity:</span>
                                                                <b>{v.quantity}</b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                    <div className="text-end mt-2 font-12 cart-subtotal">
                                        <span> Item Subtotal ({window.mct}): <b>{getSubTotal()}</b></span>
                                    </div>
                                </div>
                                {/* Modal footer */}
                                <div className="modal-footer text-center">
                                    <div className="modal-footer-actions">
                                        <button onClick={() => { onHide() }}
                                            type="button" className="bs5 btn btn-secondary btn-sm"
                                            data-dismiss="modal">
                                            CONTINUE SHOPPING
                                        </button>
                                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                            onClick={() => { window.location.href = Cart.getCartPageRouteURL() }}
                                            data-dismiss="modal">
                                            VIEW CART
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Modal>
            </div>
        </>
    );
}

export default AddedToCartBomPopup;